import React from 'react';
import ReactDOM from 'react-dom';
import Appointments from './pages/Appointments';
import './App.css';
import 'antd/dist/antd.css';
import { RendererParams } from './react-app-env';

const containersCreated: Set<string> = new Set();

function renderAppt(inputParams: RendererParams) {
    const { containerId, routeParams, queryParams } = inputParams;
    const urlQueryParams = new URLSearchParams(queryParams);

    ReactDOM.render(
        <Appointments
            section={routeParams.section}
            cId={routeParams.cId}
            date={urlQueryParams.get('date')}
        />,
        document.getElementById(containerId),
    );

    addUnMountEventListener({ containerId });
}

function addUnMountEventListener({ containerId }: { containerId: string }) {
    if (!containersCreated.has(containerId)) {
        containersCreated.add(containerId);
        window.addEventListener('eka-event', destroyContainerEventListener as EventListener);
    }
}

function destroyContainerEventListener(
    e: CustomEvent<{ containerId: string; type: 'DESTROY_CONTAINER' }>,
) {
    console.log('In event listener', 'before check');
    const containerToDestory = e.detail.containerId;
    if (e.detail.type === 'DESTROY_CONTAINER' && containersCreated.has(containerToDestory)) {
        console.log('In event listener', 'check passed');
        const nodeOfMountedApp = document.getElementById(containerToDestory);
        if (!!nodeOfMountedApp) {
            console.log('Node found', 'unmounting node');
            containersCreated.delete(containerToDestory);
            ReactDOM.unmountComponentAtNode(nodeOfMountedApp);
            window.removeEventListener('eka-event', destroyContainerEventListener as EventListener);
        }
    }
}

window.renderAppt = renderAppt;

if (window.APPT_CONFIGS) {
    renderAppt(window.APPT_CONFIGS);
}
